// extracted by mini-css-extract-plugin
module.exports = {"ModalCloseButton":"Modal_ModalCloseButton__nQRG_"};